import { Plugin } from 'vue';
import { install } from './plugin';
export { useImageBox } from './imageBox';

export default {
  install,
} as Plugin;
